import { categorySchema, type Category, type UpdateCategoryBody } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const patchCategory = (id: string, body: UpdateCategoryBody): Promise<unknown> =>
  apiRequest<unknown>(`/categories/${id}`, { method: 'PATCH', body });

export const updateCategory = async (id: string, body: UpdateCategoryBody): Promise<Category> =>
  categorySchema.parse(await patchCategory(id, body));
